export default {
  namespaced: true,
  getters: {
    getPublicProfileByServiceProviderIdentifier: (
      _,
      __,
      { entities: { publicProfiles } }
    ) => serviceProviderUserIdentifier =>
      Object.values(publicProfiles).find(
        publicProfile =>
          publicProfile.service_provider.identifier
          === serviceProviderUserIdentifier
          || publicProfile.service_provider.id
          === serviceProviderUserIdentifier
      ),

    getPublicProfileByServiceProviderIdentifierAndOccupationId: (
      _,
      __,
      { entities: { publicProfiles } }
    ) => (serviceProviderUserIdentifier, serviceProviderOccupationId) =>
      Object.values(publicProfiles).find(
        publicProfile =>
          (publicProfile.service_provider.identifier === serviceProviderUserIdentifier
          || publicProfile.service_provider.id === serviceProviderUserIdentifier)
          && publicProfile.occupation_id === serviceProviderOccupationId
      ),
  },
};
